module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentType, {
    tag: "component",
    staticClass: "button",
    class: {
      'button_active': _vm.active, 'button_disabled': _vm.disabled
    },
    attrs: {
      "to": _vm.linkName
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.indicator) ? _c('div', {
    staticClass: "button__indicator"
  }, [_vm._v(_vm._s(_vm.indicator))]) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673b2b28","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/profilemenu/components/button/ProfileButton.vue
// module id = 9f9614746efed48c7a77
// module chunks = 89